//import { Dropdown } from '../../../../medtronic_bs5_diabetes/src/js/_bootstrap';

(function ($, Drupal, once) {
	Drupal.behaviors.autocompleteCountry = {
	  attach: function (context, settings) {
      once('autocompleteCountryBehavior', 'html', context).forEach( function (element) {  

        const DEFAULTS = {
          threshold: 2,
          maximumItems: 100,
          highlightTyped: true,
          highlightClass: 'text-primary',
          label: 'label',
          value: 'value',
          country: 'country',
          showValue: false,
          showValueBeforeLabel: false,
        };

        class Autocomplete {
          constructor(field, options) {
            this.field = field;
            this.options = Object.assign({}, DEFAULTS, options);
            this.dropdown = null;
            this.parentfield = null;
            this.parentdropdown = null;
            this.selectdropdown = null;

            const idparent = '#' + this.options.idParent;

            if (document.querySelector(idparent + ' .country-name')) {
              this.select = document.querySelector(idparent + ' .country-name');
            }
            if (document.querySelector(idparent + ' .dropdown-country-switcher')) {
              this.parentfield = document.querySelector(idparent + ' .dropdown-country-switcher');
            }
            if (document.querySelector(idparent + ' .wrap-dropdown-select-country-switcher')) {
              this.selectdiv = document.querySelector(idparent + ' .wrap-dropdown-select-country-switcher');
            }
            if (document.querySelector(idparent + ' .dropdown-select-country-switcher')) {
              this.selectbox = document.querySelector(idparent + ' .dropdown-select-country-switcher');
            }
            if (document.querySelector(idparent + ' .save-country')) {
              this.savebtn = document.querySelector(idparent + ' .save-country');
            }

            const dropdown = ce(`<div class="country-menu"></div>`);

            if (this.options.dropdownClass)
              dropdown.classList.add(this.options.dropdownClass);

            insertAfter(dropdown, field);

            this.parentfield.removeAttribute('data-bs-toggle');
            this.parentdropdown = $(idparent + ' .dropdown-country-switcher');

            $(idparent + ' .country-switcher-link > .dropdown').on(
              {"hide.bs.dropdown":  function() {
                  $('.wrap-dropdown-select-country-switcher, .wrap-select-country-switcher .dropdown-menu').removeClass('show');
                },
               "show.bs.dropdown":  function() {
                  if (idparent == '#bottom-header') {
                    setTimeout(() => {
                      document.querySelector(idparent).scrollTo({
                        top: getOffsetTop(document.querySelector(idparent + ' .dropdown-country-switcher .dropdown-menu')) + 300,
                        behavior: 'smooth',
                      });   
                    }, 200);
                  }
                }
              });
            
            $(idparent + ' .country-switcher-link > .dropdown > .dropdown-menu').on("click", function(e){
              e.stopPropagation();
              e.preventDefault();
            });

            /*$(idparent + ' .save-country').on("click", function(e){
              window.location.href = $(this).attr('href');
            });*/

            $(idparent + ' .wrap-dropdown-select-country-switcher').on("click", function(e){
                $(this).next('.dropdown-menu').toggleClass('show');
                $(this).toggleClass('show');
                $(idparent + ' .country-name').value = '';
                $(idparent + ' .country-name').focus();
                e.stopPropagation();
                e.preventDefault();
            });

            this.selectbox.addEventListener('click', (e) => {
              this.createItems(idparent);
              if (idparent == '#bottom-header') {
                setTimeout(() => {                
                  document.querySelector(idparent).scrollTo({
                    top: getOffsetTop(document.querySelector(idparent + ' .wrap-select-country-switcher')),
                    behavior: 'smooth',
                  });
                }, 200);
              }
            });

            field.addEventListener('click', (e) => {  
              this.createItems(idparent);
            });

            field.addEventListener('input', () => {
              if (this.options.onInput)
                this.options.onInput(this.field.value);
              this.renderIfNeeded(idparent);
            });

            field.addEventListener('keydown', (e) => {
              if (e.keyCode === 27) {
                this.parentdropdown.dropdown('toggle');
                return;
              }
              /*if (e.keyCode === 40) {
                
                //this.dropdown._menu.children[0]?.focus();
                document.querySelector('#top-header .country-menu').children[0].focus();
                //document.querySelector('#top-header .country-menu').children[0].scrollIntoView();
                return;
              }*/
            });

          }

          /*setData(data) {
            this.options.data = data;
            this.renderIfNeeded();
          }*/

          renderIfNeeded(idparent) {
            if (this.createItems(idparent) === 0)        
              this.field.click();
          }

          createItem(lookup, item) {
            let label;
            if (this.options.highlightTyped) {
              const idx = removeDiacritics(item.label)
                  .toLowerCase()
                  .indexOf(removeDiacritics(lookup).toLowerCase());
              const className = Array.isArray(this.options.highlightClass) ? this.options.highlightClass.join(' ')
                : (typeof this.options.highlightClass == 'string' ? this.options.highlightClass : '');
              label = item.label.substring(0, idx)
                + `<span class="${className}">${item.label.substring(idx, idx + lookup.length)}</span>`
                + item.label.substring(idx + lookup.length, item.label.length);
            } else {
              label = item.label;
            }
            if (this.options.showValue) {
              if (this.options.showValueBeforeLabel) {
                label = `${item.value} ${label}`;
              } else {
                label += ` ${item.value}`;
              }
            }
            let dataClass = 'icon-' + item.country.toLowerCase();
            return ce(`<button type="button" class="country-item ${dataClass}" data-label="${item.label}" data-value="${item.value}" data-country="${item.country}" data-ga-element="country_selected" data-ga-section="country_selector_menu" data-ga-title="${item.country}">${label}</button>`);
          }

          createItems(idparent) {
            const lookup = this.field.value;
            const items = this.field.nextSibling;
            items.innerHTML = '';
            const keys = Object.keys(this.options.data);
            let count = 0;
            for (let i = 0; i < keys.length; i++) {
              const key = keys[i];
              const entry = this.options.data[key];
              const item = {
                  label: this.options.label ? entry[this.options.label] : key,
                  value: this.options.value ? entry[this.options.value] : entry,
                  country: this.options.country ? entry[this.options.country] : entry,
              };
              if (removeDiacritics(item.label).toLowerCase().indexOf(removeDiacritics(lookup).toLowerCase()) >= 0) {
                items.appendChild(this.createItem(lookup, item));
                if (this.options.maximumItems > 0 && ++count >= this.options.maximumItems)
                  break;
              }
            }
            this.field.nextSibling.querySelectorAll('.country-item').forEach((item) => {
              item.addEventListener('click', (e) => {
                let dataLabel = item.getAttribute('data-label');
                let dataValue = item.getAttribute('data-value');
                let dataCountry = item.getAttribute('data-country');
                let dataClass = 'icon-' + dataCountry.toLowerCase();
                document.querySelectorAll('.dropdown-select-country-switcher').forEach(function callback(element, index) {
                  element.value = dataLabel;
                  removeClassByPrefix(element.parentNode, 'icon-');
                  element.parentNode.classList.add(dataClass);
                });
                document.querySelectorAll('.save-country').forEach(function callback(element, index) {
                  element.href = '#';
                  if (document.body.classList.contains('it-IT')) {
                    document.getElementById('country-next-btn').setAttribute("href", dataValue);
                    element.setAttribute("onclick", "jQuery(\'#country-next-popup\').modal(\'show\')");
                  } else {
                    let href =  'var meta = document.createElement(\'meta\'); meta.name = "referrer"; meta.content = "no-referrer"; document.getElementsByTagName(\'head\')[0].appendChild(meta);window.location.href = \'' + dataValue + '\';'; 
                    element.setAttribute('onclick', href);
                  }
                });
                $('.wrap-dropdown-select-country-switcher, .wrap-select-country-switcher .dropdown-menu').removeClass('show');
              })
            });
            //Add SimpleBar
            new window.SimpleBar(document.querySelector(idparent + ' .country-menu'));
            return items.childNodes.length;
          }
        }

        function getOffsetTop(element) {
          return element ? (element.offsetTop + getOffsetTop(element.offsetParent)) : 0;
        }

        function removeClassByPrefix(el, prefix) {
          var regx = new RegExp('\\b' + prefix + '(.*)?\\b', 'g');
          el.className = el.className.replace(regx, '');
          return el;
        }

        /**
         * @param html
         * @returns {Node}
         */
        function ce(html) {
          let div = document.createElement('div');
          div.innerHTML = html;
          return div.firstChild;
        }

        /**
         * @param elem
         * @param refElem
         * @returns {*}
         */
        function insertAfter(elem, refElem) {
          return refElem.parentNode.insertBefore(elem, refElem.nextSibling);
        }

        /**
         * @param {String} str
         * @returns {String}
         */
        function removeDiacritics(str) {
          /*return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');*/
          return simplifyArabic(str);   
        }

        var arabicNormChar = {
        'ك': 'ک', 'ﻷ': 'لا', 'ؤ': 'و', 'ى': 'ی', 'ي': 'ی', 'ئ': 'ی', 'أ': 'ا', 'إ': 'ا', 'آ': 'ا', 'ٱ': 'ا', 'ٳ': 'ا', 'ة': 'ه', 'ء': '', 'ِ': '', 'ْ': '', 'ُ': '', 'َ': '', 'ّ': '', 'ٍ': '', 'ً': '', 'ٌ': '', 'ٓ': '', 'ٰ': '', 'ٔ': '', '�': ''
        }
    
        var simplifyArabic  = function (str) {
            return str.replace(/[^\u0000-\u007E]/g, function(a){ 
                var retval = arabicNormChar[a]
                if (retval == undefined) {retval = a}
                return retval; 
            }).normalize('NFKD').toLowerCase();
        }

        document.querySelectorAll('.dropdown-select-country-switcher').forEach(function callback(element, index) {
          element.value = element.defaultValue;
        }); 

        let dataCountry = [
          {"label":"Algeria (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"dz"},
          {"label":"الجزائر (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"dz"},
          {"label":"Australia (EN)","value":"https://www.medtronic-diabetes.com.au/","country":"au"},
          {"label":"Bahrain (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"bh"},
          {"label":"البحرين (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"bh"},
          {"label":"Belgique (FR)","value":"https://www.medtronic-diabetes.com/fr-BE","country":"be"},
          {"label":"België (NL)","value":"https://www.medtronic-diabetes.com/nl-BE","country":"be"},
          {"label":"Canada (EN)","value":"https://www.medtronic.com/ca-en/diabetes/home.html","country":"ca"},
          {"label":"Česká republika (CS)","value":"https://www.medtronic-diabetes.com/cs-CZ","country":"cz"},
          {"label":"China (ZH)","value":"https://www.medtronic.com/cn-zh/your-health.html","country":"cn"},
          {"label":"Danmark (DA)","value":"https://www.medtronic-diabetes.com/da-DK","country":"dk"},
          {"label":"Deutschland (DE)","value":"https://www.medtronic-diabetes.com/de-DE", "country":"de"},
          {"label":"Egypt (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"eg"},
          {"label":"مصر (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"eg"},
          {"label":"España (ES)","value":"https://www.medtronic-diabetes.com/es-ES","country":"es"},
          {"label":"Ελλάδα (EL)","value":"https://www.medtronic-diabetes.com/el-GR","country":"gr"},
          {"label":"France (FR)","value":"https://parlonsdiabete.com/","country":"fr"},      
          {"label":"Hrvatska (HR)","value":"https://www.medtronic-diabetes.com/hr-HR","country":"hr"},
          {"label":"Ísland (IS)","value":"https://www.medtronic-diabetes.com/is-IS","country":"is"},
          {"label":"India (EN)","value":"https://www.medtronic-diabetes.in/","country":"in"},
          {"label":"Iraq (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"iq"},
          {"label":"العراق (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"iq"},
          {"label":"Ireland (EN)","value":"https://www.medtronic-diabetes.com/en-IE","country":"ie"},
          {"label":"Israel (EN)","value":"https://www.medtronic-diabetes.com/en-IL","country":"il"},
          {"label":"ישראל (HE)","value":"https://www.medtronic-diabetes.com/he-IL","country":"il"},
          {"label":"Italia (IT)","value":"https://www.medtronic-diabetes.com/it-IT","country":"it"},
          {"label":"Japan (JA)","value":"https://www.medtronic.com/jp-ja/your-health/conditions/diabetes.html","country":"jp"},
          {"label":"Jordan (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"jo"},
          {"label":"الأردن (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"jo"},
          {"label":"Kenya (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"ke"},
          {"label":"Kuwait (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"kw"},
          {"label":"الكويت (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"kw"},
          {"label":"Lebanon (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"lb"},
          {"label":"لبنان (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"lb"},
          {"label":"Libya (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"ly"},
          {"label":"ليبيا (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"ly"},
          {"label":"Magyarország (HU)","value":"https://www.medtronic-diabetes.com/hu-HU","country":"hu"},
          {"label":"Morocco (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"ma"},
          {"label":"المغرب (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"ma"},
          {"label":"Nederland (NL)","value":"https://www.medtronic-diabetes.com/nl-NL","country":"nl"},
          {"label":"Norge (NO)","value":"https://www.medtronic-diabetes.com/no-NO","country":"no"},
          {"label":"Oman (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"om"},
          {"label":"عمان (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"om"},
          {"label":"Österreich (DE)","value":"https://www.medtronic-diabetes.com/de-AT","country":"at"},
          {"label":"Polska (PL)","value":"https://www.medtronic-diabetes.com/pl-PL","country":"pl"},
          {"label":"Portugal (PT)","value":"https://www.medtronic-diabetes.com/pt-PT","country":"pt"},
          {"label":"Qatar (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"qa"},
          {"label":"قطر (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"qa"},
          {"label":"România (RO)","value":"https://www.medtronic-diabetes.com/ro-RO","country":"ro"},
          {"label":"Россия (RU)","value":"https://www.medtronic-diabetes.com/ru-RU","country":"ru"},
          {"label":"Saudi Arabia (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"sa"},
          {"label":"المملكة العربية السعودية (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"sa"},
          {"label":"Slovensko (SK)","value":"https://www.medtronic-diabetes.com/sk-SK","country":"sk"},
          {"label":"South Africa (EN)","value":"https://www.medtronic-diabetes.com/en-ZA","country":"za"},
          {"label":"Suomi (FI)","value":"https://www.medtronic-diabetes.com/fi-FI","country":"fi"},
          {"label":"Sverige (SV)","value":"https://www.medtronic-diabetes.com/sv-SE","country":"se"},
          {"label":"Schweiz (DE)","value":"https://www.medtronic-diabetes.com/de-CH","country":"ch"},
          {"label":"Suisse (FR)","value":"https://www.medtronic-diabetes.com/fr-CH","country":"ch"},
          {"label":"Tunisia (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"tn"},
          {"label":"تونس (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"tn"},
          {"label":"Türkiye (TR)","value":"https://www.medtronic-diabetes.com/tr-TR","country":"tr"},
          {"label":"United Arab Emirates (EN)","value":"https://www.medtronic-diabetes.com/en-MENA","country":"ae"},
          {"label":"الإمارات العربية المتحدة (AR)","value":"https://www.medtronic-diabetes.com/ar-MENA","country":"ae"},
          {"label":"United Kingdom (EN)","value":"https://www.medtronic-diabetes.com/en-gb","country":"gb"},
          {"label":"United States (EN)","value":"https://www.medtronicdiabetes.com/","country":"us"},
        ];

        function initCountrySwitcher() { 
          var auto_complete_desktop = new Autocomplete(document.querySelector('#top-header .country-name'), {
            data: dataCountry,
            idParent: 'top-header',
            maximumItems: 100,
            highlightTyped: true,
            highlightClass: 'fw-bold text-primary',
            dropdownOptions: {autoClose:false}
          }).createItems('#top-header');
          var auto_complete_mobile = new Autocomplete(document.querySelector('#bottom-header .country-name'), {
            data: dataCountry,
            idParent: 'bottom-header',
            maximumItems: 100,
            highlightTyped: true,
            highlightClass: 'fw-bold text-primary',
            dropdownOptions: {autoClose:false}
          }).createItems('#bottom-header');         
        };

        function startCountrySwitcher() {
          let i = 0;
          let cs = setInterval(function() {
            if (document.querySelector('#top-header .country-name') && document.querySelector('#bottom-header .country-name')){
                clearInterval(cs);        
                initCountrySwitcher();
            }
            if (i > 100) {
              clearInterval(cs);
            }
            i++;
          }, 100);
        }

        if (document.body.classList.contains('user-logged-in')) {
          startCountrySwitcher();
        } else {
          if (document.querySelector('#top-header .country-name') && document.querySelector('#bottom-header .country-name')) {
            initCountrySwitcher();
          } else {
            startCountrySwitcher();
          }
        }
        
      });
    }
}
} (jQuery, Drupal, once));